import { yellow } from './style/colors';

export function getHighlightedText(text: string, highlight?: string) {
  // Split on highlight term and include term into parts, ignore case
  if (!highlight) return <span>{text}</span>;
  const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
  return (
    <span>
      {' '}
      {parts.map((part, i) => (
        <span
          key={i}
          style={
            part.toLowerCase() === highlight.toLowerCase()
              ? { fontWeight: 'bold', backgroundColor: yellow }
              : {}
          }
        >
          {part}
        </span>
      ))}{' '}
    </span>
  );
}
